import apiClient from "@services/apiClient";
import { ATP_API_URL } from "@config/apiconfig";

/**
 * Fetch all clients with optional filters
 * @param {string} status - Client status filter (e.g., "active", "inactive", "deleted")
 * @returns {Promise} Response data
 */
export const fetchClientsList = async (status = null) => {
  try {
    const url = ATP_API_URL.GET_ALL_CLIENTS;

    const payload = {
      status: status || "",
    };

    const response = await apiClient.post(url, payload);

    if (response?.data?.success) {
      return {
        success: true,
        data: response.data.data || [],
        total: response.data.total || 0,
        active_clients: response.data.active_clients || 0,
        inactive_clients: response.data.inactive_clients || 0,
        deleted_clients: response.data.deleted_clients || 0,
      };
    } else {
      return {
        success: false,
        data: [],
        message: response.data?.message || "Failed to fetch clients",
      };
    }
  } catch (error) {
    return {
      success: false,
      data: [],
      message: error.message || "Failed to fetch clients",
    };
  }
};

/**
 * Create a new client
 * @param {object} clientData - Client data to create
 * @returns {Promise} Response data
 */
export const createClient = async (clientData) => {
  try {
    const response = await apiClient.post(
      ATP_API_URL.CREATE_CLIENT,
      clientData,
    );

    if (response?.data?.status) {
      return { success: true, data: response.data };
    } else {
      return {
        success: false,
        message: response.data?.message || "Failed to create client",
      };
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Update client status
 * @param {object} payload - { clientId: number, status: string }
 * @returns {Promise} Response data
 */
export const updateClient = async (payload) => {
  try {
    const response = await apiClient.post(ATP_API_URL.UPDATE_CLIENT, payload);

    if (response?.data?.status) {
      return { success: true, data: response.data };
    } else {
      return {
        success: false,
        message: response.data?.message || "Failed to update client",
      };
    }
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a client
 * @param {string} clientId - Client ID
 * @param {object} userData - User data (id, name, email, role)
 * @returns {Promise} Response data
 */
export const deleteClient = async (clientId, payload) => {
  try {
    const url = `${ATP_API_URL.DELETE_CLIENT}/${clientId}`;
    const response = await apiClient.post(url, payload);

    if (response?.data?.status) {
      return { success: true, data: response.data };
    } else {
      return {
        success: false,
        message: response.data?.message || "Failed to delete client",
      };
    }
  } catch (error) {
    throw error;
  }
};
